import React, { useRef, useEffect, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Paper, Tooltip, Typography } from '@mui/material';

import AuthContext from '../../../store/auth-context';
import FormControls from '../FormControls/FormControls';
import classes from '../../CSS/standard-form.module.css';

const LoginForm = (props) => {
  const { toggleShowForm, setNotify } = props;

  const authCtx = useContext(AuthContext);
  const emailRef = useRef();
  const passwordRef = useRef();

  const [isSubmitting, setIsSubmitting] = useState(false);

  let baseApiUploadedImagesPath = authCtx.baseApiUploadedImagesPath;
  const leftAdImage = 'login_images/sample_ad_400w.png';
  // const leftAdImage = '';
  const leftAdImageFull = 'login_images/sample_ad.png';
  const rightAdImage = 'login_images/sample_ad_400w.png';
  const rightAdImageFull = 'login_images/sample_ad.png';
  const displayAdImages = false;

  const loginFormVersion = 3;

  // const adImage600h = 'login_images/aba_ad_600h.png';
  // const adImage600Full = 'login_images/aba_ad_full.png';
  // const adImage600h = 'login_images/plum_ad_600h.png';
  // const adImage600Full = 'login_images/plum_ad_full.png';
  const adImage600h = 'login_images/levain_ad_600h.png';
  const adImage600Full = 'login_images/levain_ad_full.png';

  useEffect(() => {
    // emailRef.current.focus();
  }, []);

  const submitHandler = (event) => {
    event.preventDefault();

    // EXIT if we are already sending a request
    if (isSubmitting) return;

    const enteredEmail = emailRef.current.value;
    const enteredPassword = passwordRef.current.value;

    // Lock the form
    setIsSubmitting(true);

    setNotify({
      isOpen: true,
      message: 'Sending Request...',
      type: 'info',
    });

    fetch(authCtx.baseApiUrl + 'sessions', {
      method: 'POST',
      body: JSON.stringify({
        email: enteredEmail,
        password: enteredPassword,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        // Unlock the form
        setIsSubmitting(false);

        if (res.ok) {
          emailRef.current.value = '';
          passwordRef.current.value = '';

          return res.json().then((responseData) => {
            // console.log(' -- login -- ');
            // console.log(responseData);
            const expiresInMilliseconds = +responseData.data.access_token_expires_in * 1000;
            const expiryDateTime = new Date(new Date().getTime() + expiresInMilliseconds);

            const refreshTokenExpiresInMilliseconds =
              +responseData.data.refresh_token_expires_in * 1000;
            const refreshTokenExpiryDateTime = new Date(
              new Date().getTime() + refreshTokenExpiresInMilliseconds
            );
           

            authCtx.login(
              responseData.data.user_uuid,
              responseData.data.user_name,
              responseData.data.user_status,
              responseData.data.user_role_type,
              responseData.data.session_id,
              responseData.data.access_token,
              expiryDateTime,
              responseData.data.refresh_token,
              refreshTokenExpiryDateTime,
              responseData.data.org_uuid,
              responseData.data.org_name,
              responseData.data.org_type,
              responseData.data.org_status,
              responseData.data.location_uuid,
              responseData.data.location_name,
              responseData.data.location_city,
              responseData.data.location_state,
              responseData.data.location_status,
              responseData.data.user_details,
              responseData.data.org_details,
              responseData.data.multiple_restaurants
            );
          });
        } else {
          return res.json().then((responseData) => {
            if (
              responseData &&
              Array.isArray(responseData.messages) &&
              responseData.messages.length
            ) {
              const messageText = responseData.messages.map((message) => `${message}`).join(', ');
              setNotify({ isOpen: true, message: messageText, type: 'error' });
            } else {
              setNotify({
                isOpen: true,
                message: 'Login Failed - Email or Password Not Valid',
                type: 'error',
              });
            }
          });
        }
      })
      .catch((err) => {
        setNotify({
          isOpen: true,
          // message: 'Login Failed - Email or Password Not Valid',
          message: 'Something went wrong, please try again later.',
          type: 'error',
        });
      });

    // Delay the unlock by 2 seconds
    setTimeout(() => {
      // Unlock the form.
      setIsSubmitting(false);
    }, 2000);
  };


  return (
    // <Box sx={{ display: 'flex', gap: '30px', alignItems: 'center' }}>
    <Box sx={{display: 'flex', justifyContent: 'center' }}>


      {/* Use code above when displayAdImages = false */}
      {/* Use code below when displayAdImages = true */}
      {/* <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}> */}

      {/* <Box sx={{ display: 'flex', gap: '30px', alignContent: 'flex-start' }}> */}
      {/* <Box sx={{ display: 'flex', gap: '30px', alignItems: 'center', border: '1px solid red;' }}> */}
      {/* <Box sx={{ display: 'flex', gap: '30px', alignItems: 'center', height: '100%' }}> */}

      {/* <Box sx={{ display: 'flex', gap: '30px', alignItems: 'center', height: 'calc(100vh - 200px)', border: '1px solid red;' }}></Box> */}



    {loginFormVersion === 3 ? (
      <Box sx={{ display: 'flex' }}>
        
        <Box className='login-form' sx={{ height: '600px', backgroundColor: 'white'}}>
          <Box>
            <Typography variant='h5' className={classes['mui-form-header']}>
              Login
            </Typography>

            <form onSubmit={submitHandler}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2rem', pt: '4rem' }}>
                <FormControls.InputControl
                  type='email'
                  name='email'
                  label='Email'
                  inputRef={emailRef}
                  autoComplete='username'
                  required
                  className={classes['mui-control']}
                />
                <FormControls.InputControl
                  type='password'
                  name='password'
                  label='Password'
                  inputRef={passwordRef}
                  autoComplete='current-password'
                  required
                  className={classes['mui-control']}
                />
              </Box>
              {/* <Box component='div' className={classes.actions}>
                  <Link to='/forgot-password'>
                    <Typography>Forgot your Password?</Typography>
                  </Link>
                </Box> */}

              <Box component='div' className={classes.actions}>
                <FormControls.ButtonControl 
                // text='Login' 
                text={isSubmitting ? 'Logging in...' : 'Login'}
                type='submit' 
                disabled={isSubmitting}
                />
              </Box>

              <Box align='center' sx={{ pt: '2rem' }}>
                <Button variant='text' onClick={() => toggleShowForm('ForgotPassword')}>
                  Forgot your Password?
                </Button>
              </Box>
            </form>
          </Box>

          {/* <Divider sx={{ my: '3rem' }} /> */}

          <Box>
            <Box component='div'>
              <Typography align='center'>Don't have an Account?</Typography>
            </Box>
            <Box align='center'>
              <Link to='/team-main'>
                <Typography component='div'>Create a Team Account</Typography>
              </Link>
              <Typography component='div'>or</Typography>
              <Link to='/vendor-main'>
                <Typography component='div'>Create a Vendor Account</Typography>
              </Link>
            </Box>
          </Box>

        </Box>

        {displayAdImages ? (
          <Box>
            {adImage600h ? (
              <Tooltip title='Click to open the full size Ad Image in a New Tab'>
                <a
                  href={baseApiUploadedImagesPath + adImage600Full}
                  target='_blank'
                  rel='noreferrer'
                >
                  <img
                    src={baseApiUploadedImagesPath + adImage600h}
                    alt='Left Side Ad'
                    className='login-form-ad-image-v3'
                  />
                </a>
              </Tooltip>
            ) : (
              <Box>NO IMAGE</Box>
            )}
          </Box>
        ) : null}

      </Box>
    ) : null}




    {loginFormVersion === 2 ? (
      <Box sx={{ display: 'flex', gap: '30px', alignItems: 'center' }}>

        {displayAdImages ? (
          <Box>
            {leftAdImage ? (
              <Tooltip title='Click to open the full size Ad Image in a New Tab'>
                <a
                  href={baseApiUploadedImagesPath + leftAdImageFull}
                  target='_blank'
                  rel='noreferrer'
                >
                  <img
                    src={baseApiUploadedImagesPath + leftAdImage}
                    alt='Left Side Ad'
                    className='login-form-ad-image'
                  />
                </a>
              </Tooltip>
            ) : (
              <Box>NO IMAGE</Box>
            )}
          </Box>
        ) : null}

        <Paper elevation={4} className='login-form'>
          <Box>
            <Typography variant='h5' className={classes['mui-form-header']}>
              Login
            </Typography>

            <form onSubmit={submitHandler}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2rem', pt: '4rem' }}>
                <FormControls.InputControl
                  type='email'
                  name='email'
                  label='Email'
                  inputRef={emailRef}
                  autoComplete='username'
                  required
                  className={classes['mui-control']}
                />
                <FormControls.InputControl
                  type='password'
                  name='password'
                  label='Password'
                  inputRef={passwordRef}
                  autoComplete='current-password'
                  required
                  className={classes['mui-control']}
                />
              </Box>
              {/* <Box component='div' className={classes.actions}>
                  <Link to='/forgot-password'>
                    <Typography>Forgot your Password?</Typography>
                  </Link>
                </Box> */}

              <Box component='div' className={classes.actions}>
                <FormControls.ButtonControl text='Login' type='submit' />
              </Box>

              <Box align='center' sx={{ pt: '2rem' }}>
                <Button variant='text' onClick={() => toggleShowForm('ForgotPassword')}>
                  Forgot your Password?
                </Button>
              </Box>
            </form>
          </Box>

          {/* <Divider sx={{ my: '3rem' }} /> */}

          <Box>
            <Box component='div'>
              <Typography align='center'>Don't have an Account?</Typography>
            </Box>
            <Box align='center'>
              <Link to='/team-main'>
                <Typography component='div'>Create a Team Account</Typography>
              </Link>
              <Typography component='div'>or</Typography>
              <Link to='/vendor-main'>
                <Typography component='div'>Create a Vendor Account</Typography>
              </Link>
            </Box>
          </Box>

          <Box></Box>
        </Paper>

        {displayAdImages ? (
          <Box>
            {rightAdImage ? (
              <Tooltip title='Click to open the full size Ad Image in a New Tab'>
                <a
                  href={baseApiUploadedImagesPath + rightAdImageFull}
                  target='_blank'
                  rel='noreferrer'
                >
                  <img
                    src={baseApiUploadedImagesPath + rightAdImage}
                    alt='Right Side Ad'
                    className='login-form-ad-image'
                  />
                </a>
              </Tooltip>
            ) : (
              <Box>NO IMAGE</Box>
            )}
          </Box>
        ) : null}

      </Box>
    ) : null}




    {loginFormVersion === 1 ? (
      <Paper elevation={4} className='login-form'>
        <Box>
          <Typography variant='h5' className={classes['mui-form-header']}>
            Login
          </Typography>

          <form onSubmit={submitHandler}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2rem', pt: '4rem' }}>
              <FormControls.InputControl
                type='email'
                name='email'
                label='Email'
                inputRef={emailRef}
                autoComplete='username'
                required
                className={classes['mui-control']}
              />
              <FormControls.InputControl
                type='password'
                name='password'
                label='Password'
                inputRef={passwordRef}
                autoComplete='current-password'
                required
                className={classes['mui-control']}
              />
            </Box>
            {/* <Box component='div' className={classes.actions}>
                <Link to='/forgot-password'>
                  <Typography>Forgot your Password?</Typography>
                </Link>
              </Box> */}

            <Box component='div' className={classes.actions}>
              <FormControls.ButtonControl text='Login' type='submit' />
            </Box>

            <Box align='center' sx={{ pt: '2rem' }}>
              <Button variant='text' onClick={() => toggleShowForm('ForgotPassword')}>
                Forgot your Password?
              </Button>
            </Box>
          </form>
        </Box>

        {/* <Divider sx={{ my: '3rem' }} /> */}

        <Box>
          <Box component='div'>
            <Typography align='center'>Don't have an Account?</Typography>
          </Box>
          <Box align='center'>
            <Link to='/team-main'>
              <Typography component='div'>Create a Team Account</Typography>
            </Link>
            <Typography component='div'>or</Typography>
            <Link to='/vendor-main'>
              <Typography component='div'>Create a Vendor Account</Typography>
            </Link>
          </Box>
        </Box>

      </Paper>
    ) : null}




      {/* <Notification notify={notify} setNotify={setNotify} /> */}

      {/* Comment this out when displayAdImages = false */}
      {/* </Box> */}
    </Box>
  );
};

export default LoginForm;
